export default {
  message: '<p class="notify_error">ログインに失敗しました。</p>',
  position: 't',
  allowHTML: true,
  status: 'error',
  closeButton: true,
};
